import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'contract-confirm-missing-transport-dialog',
    templateUrl: './contract-confirm-missing-transport.dialog.component.html',
    styleUrls: ['./contract-confirm-missing-transport.dialog.component.scss']
})
export class ContractConfirmMissingTransportDialogComponent {
    missingDelivery: boolean;
    missingBackDelivery: boolean;

    constructor(public dialog: MatDialogRef<ContractConfirmMissingTransportDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { missingDelivery: boolean; missingBackDelivery: boolean }) {
        this.missingDelivery = data.missingDelivery;
        this.missingBackDelivery = data.missingBackDelivery;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractConfirmMissingTransportDialogComponent/contract-confirm-missing-transport.dialog.component.ts